import { useState, useEffect, RefObject } from 'react';

export default ({
  element,
  repeat = false,
  threshold = 0,
  rootMargin = '0px',
}: {
  element: RefObject<Element>;
  repeat?: boolean;
  threshold?: number;
  rootMargin?: string;
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting || repeat) {
          setIsVisible(entry.isIntersecting);
        }
      },
      { rootMargin, threshold }
    );

    element.current && observer.observe(element.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isVisible;
};
